import React, { useEffect, useState } from "react";
import api from "../api"; // added import for api instance

const WeeklyLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // updated line: use api instance instead of fetch with localhost
    api.get("/api/weekly-leaderboard/")
      .then((res) => {
        const data = res.data;
        console.log("WEEKLY LEADERBOARD DATA:", data);
        setLeaderboard(data.data || []);
        setCategories(data.categories || []);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-center mb-6">Weekly Leaderboard by Category</h1>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border px-4 py-2">User</th>
            {categories.map((cat) => (
              <th key={cat} className="border px-4 py-2">{cat}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((entry, idx) => (
            <tr key={idx}>
              <td className="border px-4 py-2">{entry.username}</td>
              {categories.map((cat) => (
                <td key={cat} className="border px-4 py-2">{entry[cat] || 0}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WeeklyLeaderboard;
